import { ControlType, FetchStatus, Property } from "../../../../../base/types";
import { ErrorMessage, Spinner } from "../../../../../widgets";
import { FC, useCallback } from "react";
import { TimeProperties, useTimeProperties } from "./TimeProperties";

import { DraftTimeComponent } from "./DraftTimeComponent";
import { IControlAttributes } from "../../../../../base/models";
import { InputLabel } from "../../InputLabel";
import { Registry } from "../../../../../base/register";
import { SimpleTime } from "./SimpleTime";
import { TimeField } from "./TimeField";

export const TimeComponent: FC<IControlAttributes> = ({
    control, className, props
}) => {
    const { status, properties, bindings, error } = useTimeProperties(props);
    const { label, required, title } = properties || {}
    const containerClass = label ? className : ''
    const inputClass = label ? '' : className

    const getTimeNode = useCallback(() => {
        const binding = bindings?.getBinding(Property.InitValue);
        switch (binding?.type) {
            case "Field":
                return <TimeField
                    id={control.controlId}
                    title={title}
                    name={binding.boundValue}
                    {...properties}
                    className={inputClass}
                />
            case "Const":
            case "Expression":
            default:
                return <SimpleTime
                    id={control.controlId}
                    title={title}
                    {...properties}
                    value={binding?.value}
                    className={inputClass}
                />
        }

        // eslint-disable-next-line
    }, [properties, bindings, control])

    switch (status) {
        case FetchStatus.Idle: return <></>
        case FetchStatus.Loading: return <Spinner show={true} />
        case FetchStatus.Error: return <ErrorMessage message={error} />
    }

    return <InputLabel
        htmlFor={control.controlId}
        title={title}
        label={label}
        required={required}
        className={containerClass}>
        {getTimeNode()}
    </InputLabel>

}

Registry.addControl({
    id: "1f76c023-2538-4269-b1c6-4457fb35025e",
    name: "Time Input",
    type: ControlType.Time,
    properties: TimeProperties,
    component: TimeComponent,
    draftComponent: DraftTimeComponent
})
